<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
	<div [innerHTML]="message"></div>
	<br/>
	<div>Type:</div>
	<div>{{type}}</div>
	<br/>
	<div>Account:</div>
	<div>{{account}}</div>
</mat-dialog-content>

<mat-dialog-actions >
	<div class="w-100 mt-3 p-2 justify-end items-center flex-row">
		<a mat-button class="dialog-btn " color="primary" (click)="onCancelClick()"><span class="text-bold uppercase">{{cancelButtonText}}</span></a>
		<a mat-button class="dialog-btn" color="primary" (click)="onConfirmClick()"><span class="text-bold uppercase">{{confirmButtonText}}</span></a>
	</div>
</mat-dialog-actions>
